module.exports = __webpack_public_path__ + "media/images/arrows/orange-right-6b33e7493cd400cef47b4291fc076430.svg";